export default {
  enterInfo: {},
  categoryList4Entering: [],
  credentialList: [],
  serverCity: {},
  serverArea: [],
  originPlace: {},
  rewards: [],
  nearbyStore: {}
}
